const translations = {
  "en": {
    "Share failed": "Share failed"
  },
  "zh-tw": {
    "Share failed": "分享失敗"
  }
};

export default translations;
